import { useQuery } from '@tanstack/react-query';

import { ROOMS_LIST_STALE_TIME } from '~teacher/hook/room/constants';
import { roomsKeys } from '~teacher/hook/room/roomsKeys';

import { getRoomShareUrl } from '../../../api/rooms/getRoomShareUrl';

interface UseRoomDetailParams {
  roomId: number;
  enabled?: boolean;
}

export function useRoomDetail({ roomId, enabled }: UseRoomDetailParams) {
  return useQuery({
    enabled: roomId !== null && enabled,
    queryKey: roomsKeys.details(roomId),
    queryFn: () => getRoomShareUrl(roomId),
    staleTime: ROOMS_LIST_STALE_TIME,
  });
}
